/**
 * Created by olga on 02.07.2025
 */

const LocationStarAnimation = cc.Sprite.extend({
    ctor: function () {
        this._super(bundles.menubar.frames.meta_star_png);

        this.trace = new cc.Sprite(bundles.menubar.frames.meta_star_trace);
        this.trace.setAnchorPoint(0.5, 0);
        this.addChild(this.trace);
        this.trace.setAlignment(this.width / 2, this.height / 2);
        this.trace.setLocalZOrder(-1);

        this.trace.scale = 0;
    },

    start: function () {
        this.scheduleUpdate();

        this.trace.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.ScaleTo(0.1, 1)
        ));
    },

    update: function (dt) {
        this._super(dt);

        this.trace.setRotation(Math.atan2(this.x - this.prevPos.x, this.y - this.prevPos.y) * 180 / Math.PI + 180);

        this.prevPos = this.getPosition();
    }
});

LocationStarAnimation.createSpendAnimation = function (options) {
    options = options || {};
    const callback = options.callback;
    const target = options.target;
    const source = options.source;
    const amount = options.amount || 1;

    const scene = cleverapps.Scenes.GetRunningScene();

    const startPosition = scene.convertToNodeSpace(source.parent.convertToWorldSpace(source.getPosition()));
    const endPosition = scene.convertToNodeSpace(target.parent.convertToWorldSpace(target.getPosition()));

    let secondPosition = cc.pMidpoint(startPosition, endPosition);
    const perp = cc.pNormalize(cc.pRPerp(cc.pSub(endPosition, startPosition)));
    secondPosition = cc.pAdd(secondPosition, cc.pMult(perp, 300));

    const delay = 0.1;

    cleverapps.effects.fire("meta.star.fly");

    for (let i = 0; i < amount; i++) {
        const star = new LocationStarAnimation();
        scene.addChild(star);
        star.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 10);
        star._setGlobalZOrder(true);
        star.setAlignment(startPosition);
        star.prevPos = startPosition;
        star.visible = false;

        star.runAction(new cc.Sequence(
            new cc.DelayTime(i * delay),
            new cc.Show(),
            new cc.CallFunc(() => {
                star.start();
            }),
            new cc.Spawn(
                new cc.Sequence(
                    new cc.ScaleTo(0.3, 1.5),
                    new cc.ScaleTo(0.3, 0.5)
                ),
                new cc.BezierTo(0.6, [startPosition, secondPosition, endPosition])
            ),
            new cc.RemoveSelf()
        ));
    }

    cleverapps.timeouts.setTimeout(callback, ((amount * delay) + 0.6) * 1000);
};
